if (!customElements.get('image-comparer')) {
  class ImageComparer extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: '.js-container',
        before: '.js-before',
        after: '.js-after',
        slider: '.image-comparer__slider',
      };

      this.config = {
        addCircle: true,
        addCircleBlur: false,
        smoothing: false,
      };
    }

    connectedCallback() {
      this.before = this.querySelector(this.selectors.before);
      this.after = this.querySelector(this.selectors.after);
      this.container = this.querySelector(this.selectors.container);

      this.instance = new ImageCompare(this.container, this.config).mount();
    }
  }

  customElements.define('image-comparer', ImageComparer);
}
